module.exports = __webpack_public_path__ + "static/media/image_31.e3c5b73c.png";